module.exports = __webpack_public_path__ + "static/media/demag55.4c08d1d4.pdf";